// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"120":"ec46d827","268":"9ebc491c","302":"fc4bd723","344":"fa6bcfdc","525":"bbc6090b","551":"facfa812","564":"4c7ae585","629":"a95241c9","770":"dd0e75b9","815":"1579669b","950":"79c834d4"}[chunkId] + ".chunk.js";
};